import React from 'react';
import { connect } from 'react-redux';
import * as fromApp from '../../store/app';

import classes from './MProgressBar.module.scss';

interface PropsFromState {
  loading: boolean;
}

interface Props extends PropsFromState {}

const MProgressBarView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return !props.loading ? (
    <React.Fragment>
      <div className={classes['background']}></div>
      <div className={`${classes['loader']} ${classes['center']}`}>
        <span></span>
      </div>
    </React.Fragment>
  ) : null;
};

MProgressBarView.displayName = 'MProgressBarView';
MProgressBarView.defaultProps = {};

const mapStateToProps = (state: fromApp.AppState) => {
  return {
    loading: !state.ui.loading,
  };
};

export default connect(mapStateToProps)(MProgressBarView);
